"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatType = void 0;
var ChatType;
(function (ChatType) {
    ChatType["General"] = "general";
    ChatType["CreateProject"] = "create-project";
    ChatType["Agent"] = "agent";
})(ChatType || (exports.ChatType = ChatType = {}));
